// extracted by mini-css-extract-plugin
module.exports = {"footer":"create-form-modal_footer__2inLQ"};